/**
 * Get the base URL for Socket.IO connections.
 *
 * Socket.IO needs the root domain, not the /api path.
 * This derives the WebSocket URL from VITE_API_URL by stripping /api.
 */
export function getSocketUrl(): string {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';

  // Strip /api or /api/ suffix if present
  return apiUrl.replace(/\/api\/?$/, '');
}
